var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSchedulerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 6,
    fill: "url(#paint0_linear_7122_7613)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7122_7613)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.31581 2.05196L7.09208 4.15188C7.22146 4.50352 7.4968 4.77887 7.84845 4.90825L9.94837 5.68452C10.2403 5.794 10.2403 6.20535 9.94837 6.31483L7.84845 7.0911C7.4968 7.22048 7.22146 7.49583 7.09208 7.84747L6.31581 9.94739C6.20633 10.2393 5.79497 10.2393 5.6855 9.94739L4.90922 7.84747C4.77984 7.49583 4.5045 7.22048 4.15285 7.0911L2.05293 6.31483C1.761 6.20535 1.761 5.794 2.05293 5.68452L4.15285 4.90825C4.5045 4.77887 4.77984 4.50352 4.90922 4.15188L5.6855 2.05196C5.79497 1.76002 6.20633 1.76002 6.31581 2.05196Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7122_7613",
    x1: 0,
    y1: 0,
    x2: 12,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8560F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#5685BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09C25A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7122_7613"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSchedulerIcon);
export default __webpack_public_path__ + "static/media/ai-scheduler-icon.c09ee1700103b2ebc89da5c8e5c51904.svg";
export { ForwardRef as ReactComponent };